import { useInfiniteQuery } from '@tanstack/react-query'
import type { ActivityListResult } from '@ayub/shared'
import { fetchActivity } from './api'

/**
 * "Tarix" bo'limi — "Yana ko'rsatish" tugmasi bilan 20 tadan qo'shib boradi (vazifa
 * talabi). `useInfiniteQuery` (`@tanstack/react-query`, LOYIHADA ALLAQACHON o'rnatilgan —
 * "yangi kutubxona qo'shmang" qoidasiga zid emas) shu naqsh uchun mo'ljallangan: sahifalar
 * ro'yxati avtomatik jamlanadi va `entityId`/`entityType` o'zgarganda (masalan admin boshqa
 * bloger kartochkasini ochsa) `queryKey` o'zgargani uchun eski sahifalar o'zi tozalanadi —
 * qo'lda `useState` bilan "page"/"items" boshqarish va reset qilish shart emas
 * (`components/payouts/Pagination.tsx`dagi RAQAMLI sahifalash naqshidan ATAYLAB farqli —
 * bu yerda vazifa "Yana ko'rsatish" (klassik "load more") so'ragan, sahifa raqamlari emas).
 */
export function useActivityHistory(entityType: string, entityId: number) {
  const query = useInfiniteQuery<ActivityListResult, Error>({
    queryKey: ['activity', entityType, entityId],
    queryFn: ({ pageParam }) => fetchActivity(entityType, entityId, pageParam as number),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const loadedSoFar = lastPage.page * lastPage.pageSize
      return loadedSoFar < lastPage.total ? lastPage.page + 1 : undefined
    },
  })

  return {
    items: query.data ? query.data.pages.flatMap((page) => page.items) : [],
    isLoading: query.isLoading,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    error: query.isError ? query.error : null,
    refetch: query.refetch,
  }
}
